import { AppSettingsService } from "../../services/appsettings.service";
import { AuthenticationService } from "../../services/authentication.service";
import { SproToasterService } from "../../sproLib/spro/services/spro-toaster/spro-toaster.service";
import { Component } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-recupMdp",
  styleUrls: ["./recupMDP.component.scss"],
  templateUrl: "./recupMDP.component.html"
})
export class cls_recupMdp {
  /* ###########################################  VARIABLES  #######################################################*/

  /** Nom de la page afin de gérer la traduction */
  public w_titre_trad = "recupMDPPage.";
  /** Loading sur récupération MDP */
  public f_loading = false;

  /** Formulaire de saisie */
  public form_recup: FormGroup;

  /* ###########################################  CONSTRUCTEUR  ####################################################*/

  /**
   * Constructeur
   */
  constructor(
    public router: Router,
    public s_authentication: AuthenticationService,
    public s_translate: TranslateService,
    public s_appsettings: AppSettingsService,
    public s_toaster: SproToasterService,
    public fb: FormBuilder
  ) {
    //Dans le cas ou on charge l'application par cette page et non par le login, on charge la langue par défaut du navigateur
    if (!this.s_translate.currentLang) {
      //Initialisation de la langue a afficher
      this.s_appsettings.proc_initLangue();
    }

    this.form_recup = this.fb.group({
      username: [],
      mail: []
    });
  }

  /* ###########################################  FONCTIONS  #######################################################*/

  /**
   * Fonction de recuperation de mot de passe en envoyant username + mail
   */
  public proc_recupMDP() {
    this.f_loading = true;

    //Verification si champ non renseigné
    if (!this.form_recup.value.username || !this.form_recup.value.mail) {
      this.f_loading = false;
      this.s_toaster.proc_toastTradError(
        this.w_titre_trad + "msg_FormInvalide"
      );
      return null;
    }

    this.s_authentication
      .proc_recupMDP(this.form_recup.value.username, this.form_recup.value.mail)
      .subscribe(
        data => {
          this.f_loading = false;
          this.s_toaster.proc_toastTradSuccess(
            this.w_titre_trad + "msg_Success"
          );
          this.router.navigate(["auth/login"]);
        },
        error => {
          this.s_appsettings.proc_gestionErreur(error);
          this.f_loading = false;
        }
      );
  }

  /**
   * Annulation - Retour à l'acceuil
   */
  public proc_boutonAnnuler() {
    this.router.navigate(["auth/login"]);
  }
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/pages/recupMDP/recupMDP.component.ts